import { Component, OnDestroy, OnInit } from '@angular/core';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableHeader } from '../../tools/card-table/models/card-table-header.model';
import { GenericTableHeaderOptions, RefreshData } from '../../tools/card-table/models/generic-table-header-options.model';
import { Subscription } from 'rxjs';
import { CardTableOptions } from '../../tools/card-table/models';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService, ToolsService, UserRightsService } from '@huge-monorepo/portal/services';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { openExportDialog } from '../../tools/export-modal/export-modal.component';

@Component({
  selector: 'huge-monorepo-radius-sim-report',
  standalone: false,
  templateUrl: './radius-sim-report.component.html',
  styleUrl: './radius-sim-report.component.scss',
})
export class RadiusSimReportComponent implements OnInit, OnDestroy {
  search = '';
  count = 10;
  offset = 0;
  orderBy = '';
  desc = false;
  currentPage = 1;
  totalItems: number;

  items: any[] = [];
  allItemsSelected = false;
  selectedItems: any[] = [];
  loading = false;
  downloadingReport = false;

  obfuscateData = false;
  authSubscription: Subscription;

  ScreenSize = ScreenSize;
  searched = false;

  simTableOptions: CardTableOptions = {
    titleProperty: 'name',
    subTitleProperty: '',
    additionalProperty: 'data',
    rowId: 'id',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: true,
    flexCardLayout: false,
    propertyRowExclusions: ['color', 'selected', 'id'],
    stylePropertyPrefix: 'devices',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  simHeaderOptions: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchPlaceholder: 'Search sims',
    DefaultDesc: true,
    EnableExport: true,
    EnableSelectAll: true,
    SortItems: [
      {
        Name: 'SimNum',
        Display: 'Name',
      },
      {
        Name: 'SimCell',
        Display: 'Cell',
      },
      {
        Name: 'Status',
        Display: 'Status',
      },
    ],
  };

  simTableHeaders: CardTableHeader[] = [
    {
      ID: 'name',
      Text: 'Name',
      Width: 15,
    },
    {
      ID: 'simCell',
      Text: 'Cell',
      Width: 15,
    },
    {
      ID: 'status',
      Text: 'Status',
      Width: 15,
    },
    {
      ID: 'ServiceProvider',
      Text: 'Service Provider',
      Width: 30,
    },
    {
      ID: 'DeviceNum',
      Text: 'Device Num',
      Width: 15,
    },
  ];

  constructor(
    private endpoints: Endpoints,
    private auth: UserRightsService,
    private genericService: GenericService,
    private tools: ToolsService,
    private dialogRef: MatDialog,
    private toastService: ToastrService,
  ) {}

  ngOnInit() {
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      this.obfuscateData = user.isObfuscated;
      this.getSims(this.orderBy, this.search, this.count, this.offset, this.desc);
    });
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  getSims(orderBy: string, search: string, count: number, offset: number, desc: boolean) {
    this.loading = true;
    const obj = {
      Online: null,
      GroupID: this.auth.GetGroupID(),
    };

    this.genericService.POST(this.endpoints.GET_SIMS(search, count, offset, orderBy, desc), obj).subscribe((resp) => {
      const simData = resp['body'];
      this.items = [];
      if (simData != null) {
        const tmpData = [];
        simData.forEach((element) => {
          const tempObj = {
            id: element.SimID,
            name: element.SimNum,
            simCell: element.SimCell,
            status: element.Status,
            selected: false,
            color: '#949494',
            serviceprovider: element.ServiceProvider ?? '',
            devicenum: element.DeviceNum ?? '',
          };

          tmpData.push(tempObj);
        });
        this.items = tmpData;
      } else {
        this.items = [];
      }

      this.totalItems = this.tools.ExtractPaginationFromHeaders(resp['headers']);

      this.loading = false;
    });
  }

  paginateSims(pageIndex: number) {
    this.offset = (pageIndex - 1) * this.count;
    this.currentPage = pageIndex;
    this.getSims(this.orderBy, this.search, this.count, this.offset, this.desc);
  }

  selectAllDevices(selected: boolean) {
    this.allItemsSelected = selected;
    if (this.items == null) {
      return;
    }
    this.items.forEach((t) => {
      t.selected = selected;
      if (selected) {
        this.selectedItems.push(t.id);
      } else {
        this.selectedItems = [];
      }
    });
  }

  selectDevice(ev) {
    const device = this.items.find((t) => t.id == ev.row.id);
    if (device != null) {
      device.selected = ev.checked;
      if (ev.checked) {
        this.selectedItems.push(ev.row.id);
      } else {
        const removeIndex = this.selectedItems.findIndex((t) => t == ev.row.id);
        this.selectedItems.splice(removeIndex, 1);
      }
    }
  }

  refreshTable(data: RefreshData): void {
    this.search = data.Search ?? '';
    if (this.search) {
      this.searched = true;
    } else {
      this.searched = false;
    }
    this.orderBy = data.Sort ?? '';
    this.desc = data.Desc ?? this.desc;
    this.offset = 0;
    this.currentPage = 1;
      this.getSims(this.orderBy, this.search, this.count, this.offset, this.desc);
  }

  onRowSelected(data: any) {
    if (data.selected) {
      // Add the ID if it isn't already in the array
      if (!this.selectedItems.includes(data.id)) {
        this.selectedItems.push(data.id);
      }
    } else {
      // Remove the ID if it exists in the array
      this.selectedItems = this.selectedItems.filter(id => id !== data.id);
    }
    this.allItemsSelected = false;
  }

  exportReport(data: RefreshData): void {
    this.downloadingReport = true;
    if (this.allItemsSelected || this.selectedItems.length > 0) {
      
      let obj = {
        SimIds: this.selectedItems,
        SimSearchTerm: this.search,
        AllSims: false,
        Blocked: null,
      };
      
      if(this.searched == false){
        obj = {
          SimIds: this.allItemsSelected ? [] : this.selectedItems,
          SimSearchTerm: this.search,
          AllSims: this.allItemsSelected,
          Blocked: null,
        };
      }

      openExportDialog(this.dialogRef, {
        endpoint: this.endpoints.DOWNLOAD_RADIUS_SIMS_REPORT,
        reqObj: obj,
      });
    } else {
      this.toastService.info('', 'No devices selected', { timeOut: 1000 });
    }
  }
}
